/* global axios */

import ApiClient from './ApiClient';

class Agents extends ApiClient {
  constructor() {
    super('agents', { accountScoped: true });
  }

  bulkInvite({ emails }) {
    return axios.post(`${this.url}/bulk_create`, {
      emails,
    });
  }

  transferCrmOwnership(agentId, targetUserId) {
    return axios.post(`${this.url}/${agentId}/transfer_crm_ownership`, {
      target_user_id: targetUserId,
    });
  }
}

export default new Agents();
